import { render, staticRenderFns } from "./vip-map.vue?vue&type=template&id=5da09230&scoped=true"
import script from "./vip-map.vue?vue&type=script&lang=js"
export * from "./vip-map.vue?vue&type=script&lang=js"
import style0 from "./vip-map.vue?vue&type=style&index=0&id=5da09230&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da09230",
  null
  
)

export default component.exports